const initFromStorage = <T>(key: string, initialValue: T): T => {
  const value = typeof window === 'undefined' ? undefined : localStorage.getItem(key);
  return value && value !== 'undefined' ? JSON.parse(value) : initialValue;
};

export const initWithStorage = <T>(
  key: string,
  initialValue: T,
): [key: string, initialValue: T] => {
  return [key, initFromStorage(key, initialValue)];
};
